var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpadrearcamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 84.4300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562-1.75781C9.76562 4.19922 14.209 8.39844 20.5078 8.39844L63.916 8.39844C70.2637 8.39844 74.6582 4.19922 74.6582-1.75781L74.6582-68.75C74.6582-74.7559 70.2637-78.9551 63.916-78.9551L20.5078-78.9551C14.209-78.9551 9.76562-74.7559 9.76562-68.75ZM16.7969-2.97852L16.7969-67.5781C16.7969-70.2637 18.5547-71.9238 21.4355-71.9238L62.9883-71.9238C65.8691-71.9238 67.627-70.2637 67.627-67.5781L67.627-2.97852C67.627-0.292969 65.8691 1.36719 62.9883 1.36719L21.4355 1.36719C18.5547 1.36719 16.7969-0.292969 16.7969-2.97852Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555-56.8848C29.541-56.8848 31.8359-59.1797 31.8359-62.0117C31.8359-64.6973 29.541-67.041 26.8555-67.041C24.0234-67.041 21.6797-64.6973 21.6797-62.0117C21.6797-59.1797 24.0234-56.8848 26.8555-56.8848Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpadrearcamera);
export default __webpack_public_path__ + "static/media/ipad.rear.camera.b109f730eb6a6399afb0963d30be6da4.svg";
export { ForwardRef as ReactComponent };